import { Filter } from "lucide-react";
import React from "react";
import { QUICK_FILTERS } from "../quickFilters";
import { Tooltip } from "./Tooltip";

const statusTextFor = (filter, active) => {
	const subject = filter.tooltipSubject || filter.label;

	if (filter.keep) {
		return active ? `${subject}: only shown` : `${subject}: included`;
	}

	return active ? `${subject}: hidden` : `${subject}: visible`;
};

export const QuickFilters = ({
	filters,
	onToggle,
	onClear,
	className = "",
}) => {
	const activeCount = QUICK_FILTERS.filter((f) => filters?.[f.id]).length;

	return (
		<div className={`flex flex-col items-end gap-1.5 ${className}`}>
			<div className="flex flex-wrap items-center justify-end gap-2">
				<span className="inline-flex h-8 w-8 items-center justify-center rounded-full text-[var(--color-text-secondary)]">
					<Filter className="h-4 w-4" aria-hidden="true" />
					<span className="sr-only">Filters</span>
				</span>

				{QUICK_FILTERS.map((f) => {
					const Icon = f.icon;
					const active = !!filters?.[f.id];
					const statusText = statusTextFor(f, active);
					return (
						<Tooltip key={f.id} content={statusText}>
							<button
								type="button"
								onClick={() => onToggle(f.id)}
								aria-label={statusText}
								aria-pressed={active}
								className={`no-hover-lift inline-flex h-8 w-8 items-center justify-center rounded-full border transition-colors ${
									active
										? "border-[var(--color-action)] bg-[var(--color-action)] text-[var(--color-action-text)] shadow-sm"
										: "border-[var(--color-border)] text-[var(--color-text-tertiary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-bg-secondary)]"
								}`}
							>
								<Icon className="w-4 h-4" />
							</button>
						</Tooltip>
					);
				})}
			</div>

			{activeCount > 0 && (
				<Tooltip content={`Clear quick filters (${activeCount} active)`}>
					<button
						type="button"
						onClick={onClear}
						aria-label={`Clear quick filters (${activeCount} active)`}
						className="no-hover-lift inline-flex h-7 items-center rounded-md border border-[var(--color-border)] px-2.5 text-xs font-medium text-[var(--color-text-secondary)] transition-colors hover:bg-[var(--color-bg-secondary)] hover:text-[var(--color-text-primary)]"
					>
						Remove filters
					</button>
				</Tooltip>
			)}
		</div>
	);
};
